<template>
  <v-dialog v-model="openFilter" persistent max-width="800">
    <v-card>
      <v-card-title>Filters</v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <v-row>
              <v-col>
                <v-menu ref="dateMenu1" max-width="350" v-model="dateMenu1" :close-on-content-click="false" :return-value.sync="filters.created" transition="scale-transition" offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="createdDateRangeText" label="Created" :prepend-inner-icon="mdiCalendar" readonly dense outlined :hide-details="!$v.filters.created.$error" v-bind="attrs" v-on="on" :error-messages="createRangeErrors"></v-text-field>
                  </template>
                  <v-date-picker v-model="filters.created" full-width no-title scrollable range>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="dateMenu1 = false;">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.dateMenu1.save(filters.created); $v.filters.created.$touch();">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-text-field v-model="filters.accountId" label="Account ID" outlined dense :hide-details="!$v.filters.accountId.$error" :error-messages="accountIDErrors" @blur="$v.filters.accountId.$touch()" @input="$v.filters.accountId.$touch()"></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-select v-model="filters.billCycle" label="Bill Cycle" :items="items.billCycle" outlined dense hide-details multiple></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-select v-model="filters.productKind" label="Product Kind" :items="items.productKind" outlined dense hide-details multiple></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-model="filters.amountFrom" type="number" prefix="£" label="Amount from" outlined dense hide-details></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="filters.amountTo" type="number" prefix="£" label="To" outlined dense hide-details></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-select v-model="filters.shortReason" :items="getCreditNoteFilters.short_reasons" item-text="value" item-value="value" label="Short Reason" :loading="loading" :no-data-text="loading ? 'Loading...' : ''" outlined dense hide-details multiple></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-select v-model="filters.departments" :items="getCreditNoteFilters.departments" :loading="loading" label="Department" outlined dense hide-details multiple></v-select>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" md="6">

            <v-row>
              <v-col>
                <v-autocomplete v-model="filters.agents" :items="getCreditNoteFilters.agents" :loading="loading" :no-data-text="loading ? 'Loading...' : ''" label="Agent" outlined dense hide-details multiple></v-autocomplete>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-select v-model="filters.preApprovalStatus" :items="items.preApprovalStatus" label="Pre-approval Status" outlined dense hide-details multiple></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-select v-model="filters.preApprovers" :items="getCreditNoteFilters.pre_approvers" :loading="loading" label="Pre-approver" :no-data-text="loading ? 'Loading...' : ''" outlined dense hide-details multiple></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-menu ref="dateMenu3" max-width="350" v-model="dateMenu3" :close-on-content-click="false" :return-value.sync="filters.preApprovalDate" transition="scale-transition" offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="preApprovalDateRangeText" label="Pre-approval Date" :prepend-inner-icon="mdiCalendar" readonly dense outlined :hide-details="!$v.filters.preApprovalDate.$error" v-bind="attrs" v-on="on" :error-messages="approvalRangeErrors"></v-text-field>
                  </template>
                  <v-date-picker v-model="filters.preApprovalDate" full-width no-title scrollable range>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="dateMenu3 = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.dateMenu3.save(filters.preApprovalDate); $v.filters.preApprovalDate.$touch();">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-select v-model="filters.approvalStatus" :items="items.approvalStatus" label="Approval Status" outlined dense hide-details multiple></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-select v-model="filters.approvers" :items="getCreditNoteFilters.approvers" :loading="loading" label="Approver" :no-data-text="loading ? 'Loading...' : ''" outlined dense hide-details multiple></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-menu ref="dateMenu2" max-width="350" v-model="dateMenu2" :close-on-content-click="false" :return-value.sync="filters.approvalDate" transition="scale-transition" offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="approvalDateRangeText" label="Approval Date" :prepend-inner-icon="mdiCalendar" readonly dense outlined :hide-details="!$v.filters.approvalDate.$error" v-bind="attrs" v-on="on" :error-messages="approvalRangeErrors"></v-text-field>
                  </template>
                  <v-date-picker v-model="filters.approvalDate" full-width no-title scrollable range>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="dateMenu2 = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.dateMenu2.save(filters.approvalDate); $v.filters.approvalDate.$touch();">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn color="warning" small outlined @click="clearFilters()">Clear</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="submitForm(filters)">Filter</v-btn>
        <v-btn color="primary" small outlined class="ml-3" @click="closeDialog">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import { mapState, mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { numeric } from "vuelidate/lib/validators";
import { mdiCalendar } from "@mdi/js";

const dateRange = (val) => {
  if(val.length === 0) return true;
  if(val.length === 2) return true;
  return false;
};

export default {
  mixins: [validationMixin],

  validations: {
    filters: {
      created: { dateRange },
      approvalDate: { dateRange },
      preApprovalDate: { dateRange },
      accountId: { numeric }
    }
  },

  data () {
    return {
      mdiCalendar,
      dateMenu1: false,
      dateMenu2: false,
      dateMenu3: false,
      filters: {
        created: [],
        accountId: "",
        billCycle: [],
        productKind: [],
        amountFrom: "",
        amountTo: "",
        shortReason: [],
        departments: [],
        agents: [],
        approvalStatus: [],
        approvers: [],
        approvalDate: [],
        preApprovalStatus: [],
        preApprovers: [],
        preApprovalDate: [],
      },
      items: {
        billCycle: ["T1","T2","T3","T4"],
        productKind: ["Telco","VoIP","Bundle","Website"],
        approvalStatus: ["None", "Approved", "Declined"],
        preApprovalStatus: ["None", "Approved", "Declined"],
        agents: [],
        approvers: [],
      },
      loading: false,
    }
  },

  props: {
    openFilter: {
      type: Boolean,
      default: false
    },
  },
  
  watch: {
    openFilter: {
      async handler(newVal) {
        if(newVal) {
          this.loading = true;
          await this.fetchCreditNoteFilters();
          this.loading = false;
        }
      }
    }
  },

  computed: {
    ...mapGetters("creditnotes", ["getCreditNoteFilters"]),

    createdDateRangeText() {
      return this.filters.created.sort().join(' - ')
    },

    approvalDateRangeText() {
      return this.filters.approvalDate.sort().join(' - ')
    },

    preApprovalDateRangeText() {
      return this.filters.preApprovalDate.sort().join(' - ')
    },

    accountIDErrors() {
      const errors = [];
      if (!this.$v.filters.accountId.$dirty) return errors;
      !this.$v.filters.accountId.numeric && errors.push("Account ID must be numeric");
      return errors;
    },

    createRangeErrors() {
      const errors = [];
      if (!this.$v.filters.created.$dirty) return errors;
      !this.$v.filters.created.dateRange && errors.push("Please select a date range");
      return errors;
    },

    approvalRangeErrors() {
      const errors = [];
      if (!this.$v.filters.approvalDate.$dirty) return errors;
      !this.$v.filters.approvalDate.dateRange && errors.push("Please select a date range");
      return errors;
    },

    preApprovalRangeErrors() {
      const errors = [];
      if (!this.$v.filters.preApprovalDate.$dirty) return errors;
      !this.$v.filters.preApprovalDate.dateRange && errors.push("Please select a date range");
      return errors;
    },
  },

  methods: {
    ...mapActions("crmUsers", ["fetchCRMUsers"]),
    ...mapActions("creditnotes", ["fetchCreditNoteFilters","fetchCreditNoteReasons", "updateCreditNoteProposalsPagination", "fetchCreditNoteDepartments"]),

    closeDialog() {
      this.$emit('closeDialog');
      this.$v.$reset();
    },

    clearFilters() {
      const filters = {
        created: [],
        accountId: "",
        billCycle: [],
        productKind: [],
        amountFrom: "",
        amountTo: "",
        shortReason: [],
        departments: [],
        agents: [],
        approvalStatus: [],
        approvers: [],
        approvalDate: [],
        preApprovalStatus: [],
        preApprovers: [],
        preApprovalDate: [],
      };
      Object.assign(this.filters, filters);
      this.$v.$reset();
    },

    submitForm(filters) {
      this.$v.$touch();
      if(!this.$v.$invalid) {
        filters.page = 1;
        this.updateCreditNoteProposalsPagination(filters);
        this.$emit('closeDialog', false);
      }
    }
  },
}
</script>

<style>

</style>
